import { makeStyles } from "@material-ui/core/styles";

export const useUnitLinksStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  fieldWrapper: {
    margin: "0 0 3px 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&:last-child": {
      marginBottom: "15px",
    },
  },
  grow: {
    flex: "1 0",
  },
  shrink: {
    flex: "0 1 42px",
    justifyContent: "center",
    textAlign: "center",
  },
  label: {
    display: "inline-block",
    marginTop: "5px",
  },
}));
